import styled from "styled-components"

export const LayoutWrapper = styled.section`
  position: relative;
  overflow: hidden;
`

export const LayoutMain = styled.main`
  background: var(--white);
  overflow: hidden;
  max-width: 100vw;
  width: 100%;
`
